import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CaseUploadService } from '../case-upload.service';
import { ClientContractPackageService } from '../client-contract-package.service';
import { ClientContractProfileService } from '../client-contract-profile.service';
import { ComponentService } from '../component.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {
  case_id: any
  caseId: any
  profile: any
  package: any
  alacart:any
  components: any[] = []
  navItems: any[] = []
  constructor(
    private componentService: ComponentService,
    private caseUploadService: CaseUploadService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private clientContractProfileService: ClientContractProfileService,
    private clientContractPackageService: ClientContractPackageService,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    console.log(this.activatedRoute.snapshot.queryParamMap.get('access_token'))
    this.getComponentDetails()
  }
  async getComponentDetails() {
    await this.getCaseDetails()
    if (this.profile != null) {
      this.components = <any[]>await this.getProfileDetails()
    } else if (this.package != null) {
      this.components = <any[]>await this.getPackageDetails()
    } else if (this.alacart != null) {
      this.components = <any[]>await this.getalacartDetails()
    }
    //    this.components = <any[]>await this.addDisplayNameToComponents()
    await this.setComponentMenuItems()
    this.navItems.push({ displayName: 'Authorize & Submit', route: 'candidate/authorization', access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'), children: [] })
    console.log("NavItems: ", this.navItems)
  }
  /*  addDisplayNameToComponents(){
      let promise = new Promise((resolve,reject)=>{
        this.tempComponents.forEach(item=>{
          this.componentService.findAComponentForCde(item.component,this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
            response=>{
              let comp = ({
                componentName : item.componentName,
                displayName :item.componentName,
                component:item.component,
                maxChecks:item.maxChecks
              })
              this.components.push(comp)
            },
            error=>{
              this.showError("Error getting display Name")
            }
          )
        })
        console.log("Components before resoving is ",this.components)
        resolve(this.components)
      })
      return promise
    }*/
  getCaseDetails() {
    let promise = new Promise((resolve, reject) => {
      this.caseUploadService.getCdeCaseDetails(this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response => {
          console.log("Got reponse from cde case details")
          this.caseId = response.caseId
          this.case_id = response._id
          this.profile = response.profile
          this.package = response.package
          this.alacart = response.componentsToCheck
          console.log("alacart",this.package),
          console.log("alacart",this.alacart)
          resolve(true)
        },
        error => {
          console.log("Error  is ", error);
          console.log("Error  Status is ", error.status);
          if (error.status == "409") {
            this.router.navigate(['candidate/alreadysubmitted'])
          } else {
            this.showError("Error reading Case Details")
            resolve(false)
          }

        })
    })
    return promise
  }
  getProfileDetails() {
    let promise = new Promise((resolve, reject) => {
      this.clientContractProfileService.getClientContractProfileDetails(this.profile + "?access_token=" + this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response2 => {
          console.log("Profile details are ", response2)
          this.navItems.push({
            displayName: 'Personal Details',
            route: 'candidate/candidatepersonaldetails',
            access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'),
            children: []
          })
          this.components = response2.clientContractProfileComponents
          this.components.forEach(item => {
            if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {
              item.displayName = 'Employment'
            } else if (item.componentName == 'address' || item.componentName == 'addressonline' || item.componentName == 'addresstelephone' || item.componentName == 'addresscomprehensive') {
              item.displayName = 'Address'
            } else if (item.componentName == 'educationcomprehensive' || item.componentName == 'educationadvanced' || item.componentName == 'education') {
              item.displayName = 'Education'
            } else if (item.componentName == 'globaldatabase') {
              item.displayName = 'Global Database'
            } else if (item.componentName == 'reference' || item.componentName == 'refbasic') {
              item.displayName = 'Reference'
            } else if (item.componentName == 'criminalrecord') {
              item.displayName = 'Criminal Record'
            } else if (item.componentName == 'courtrecord') {
              item.displayName = 'Court Record'
            } else if (item.componentName == 'identity') {
              item.displayName = 'Identity'
            }else if (item.componentName == 'gapvfn') {
              item.displayName = 'GAP'
            } else if (item.componentName == 'drugtestfive' || item.componentName == 'drugtestsix' || item.componentName == 'drugtestseven' || item.componentName == 'drugtesteight' || item.componentName == 'drugtestnine' || item.componentName == 'drugtestten') {
              item.displayName = 'Drug Test'
            } else if (item.componentName == 'cvanalysis') {
              item.displayName = 'CV Analysis'
            } else if (item.componentName == 'creditcheck') {
              item.displayName = 'Credit Check'
            } else if (item.componentName == 'uan') {
              item.displayName = 'UAN'
            }else if (item.componentName == 'twentysixas') {
              item.displayName = 'Form 26 AS'
            }else if (item.componentName == 'credittrans') {
              item.displayName = 'Credit Check - TransUnion'
            }else if (item.componentName == 'epfo') {
              item.displayName = 'EPFO Check'
            }else if (item.componentName == 'crconline') {
              item.displayName = 'Court Record (CRC ) - Law Firm (Online)'
            }else if (item.componentName == 'ofac') {
              item.displayName = 'OFAC Check'
            }else if (item.componentName == 'socialmedia') {
              item.displayName = 'Social Media Search'
            }else if(item.componentName == 'globalmediasearch'){
              item.displayName = 'Global Media Search'
            }else if(item.componentName == 'facisl3'){
              item.displayName = 'FACIS L3 Check'
            }
          })
          resolve(this.components)
        },
        error2 => {
          this.showError("Error reading profile details")
          resolve(null)
        }
      )
    })
    return promise
  }
  getPackageDetails() {
    let promise = new Promise((resolve, reject) => {
      this.clientContractPackageService.getClientContractPackageDetails(this.package + "?access_token=" + this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response2 => {
          console.log("Profile details are ", response2)
          this.navItems.push({
            displayName: 'Personal Details',
            route: 'candidate/candidatepersonaldetails',
            access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'),
            children: []
          })
          this.components = response2.clientContractPackageComponents
          this.components.forEach(item => {
            if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {
              item.displayName = 'Employment'
            } else if (item.componentName == 'address' || item.componentName == 'addressonline' || item.componentName == 'addresstelephone' || item.componentName == 'addresscomprehensive') {
              item.displayName = 'Address'
            } else if (item.componentName == 'educationcomprehensive' || item.componentName == 'educationadvanced' || item.componentName == 'education') {
              item.displayName = 'Education'
            } else if (item.componentName == 'globaldatabase') {
              item.displayName = 'Global Database'
            } else if (item.componentName == 'reference' || item.componentName == 'refbasic') {
              item.displayName = 'Reference'
            } else if (item.componentName == 'criminalrecord') {
              item.displayName = 'Criminal Record'
            } else if (item.componentName == 'courtrecord') {
              item.displayName = 'Court Record'
            } else if (item.componentName == 'identity') {
              item.displayName = 'Identity'
            } else if (item.componentName == 'gapvfn') {
              item.displayName = 'GAP'
            } else if (item.componentName == 'drugtestfive' || item.componentName == 'drugtestsix' || item.componentName == 'drugtestseven' || item.componentName == 'drugtesteight' || item.componentName == 'drugtestnine' || item.componentName == 'drugtestten') {
              item.displayName = 'Drug Test'
            } else if (item.componentName == 'cvanalysis') {
              item.displayName = 'CV Analysis'
            } else if (item.componentName == 'creditcheck') {
              item.displayName = 'Credit Check'
            }  else if (item.componentName == 'uan') {
              item.displayName = 'UAN'
            }else if (item.componentName == 'twentysixas') {
              item.displayName = 'Form 26 AS'
            }else if (item.componentName == 'credittrans') {
              item.displayName = 'Credit Check - TransUnion'
            }else if (item.componentName == 'epfo') {
              item.displayName = 'EPFO Check'
            }else if (item.componentName == 'crconline') {
              item.displayName = 'Court Record (CRC ) - Law Firm (Online)'
            }else if (item.componentName == 'ofac') {
              item.displayName = 'OFAC Check'
            }else if (item.componentName == 'socialmedia') {
              item.displayName = 'Social Media Search'
            }else if(item.componentName == 'globalmediasearch'){
              item.displayName = 'Global Media Search'
            }else if(item.componentName == 'facisl3'){
              item.displayName = 'FACIS L3 Check'
            }

          })
          resolve(this.components)
        },
        error2 => {
          this.showError("Error reading profile details")
          resolve(null)
        }
      )
    })
    return promise
  }


  ///
  getalacartDetails() {
    let promise = new Promise((resolve, reject) => {
      this.caseUploadService.getCdeCaseDetails(this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
      // this.clientContractPackageService.getClientContractComponentsDetails(this.alacart + "?access_token=" + this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response2 => {
          console.log("Profile details are ", response2)
          this.navItems.push({
            displayName: 'Personal Details',
            route: 'candidate/candidatepersonaldetails',
            access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'),
            children: []
          })
          this.components = response2.componentsToCheck
          console.log("components to check",response2)
          console.log("components to check",this.components)
          this.components.forEach(item => {
            if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {
              item.displayName = 'Employment'
            } else if (item.componentName == 'address' || item.componentName == 'addressonline' || item.componentName == 'addresstelephone' || item.componentName == 'addresscomprehensive') {
              item.displayName = 'Address'
            } else if (item.componentName == 'educationcomprehensive' || item.componentName == 'educationadvanced' || item.componentName == 'education') {
              item.displayName = 'Education'
            } else if (item.componentName == 'globaldatabase') {
              item.displayName = 'Global Database'
            } else if (item.componentName == 'reference' || item.componentName == 'refbasic') {
              item.displayName = 'Reference'
            } else if (item.componentName == 'criminalrecord') {
              item.displayName = 'Criminal Record'
            } else if (item.componentName == 'courtrecord') {
              item.displayName = 'Court Record'
            } else if (item.componentName == 'identity') {
              item.displayName = 'Identity'
            } else if (item.componentName == 'gapvfn') {
              item.displayName = 'GAP'
            } else if (item.componentName == 'drugtestfive' || item.componentName == 'drugtestsix' || item.componentName == 'drugtestseven' || item.componentName == 'drugtesteight' || item.componentName == 'drugtestnine' || item.componentName == 'drugtestten') {
              item.displayName = 'Drug Test'
            } else if (item.componentName == 'cvanalysis') {
              item.displayName = 'CV Analysis'
            } else if (item.componentName == 'creditcheck') {
              item.displayName = 'Credit Check'
            }  else if (item.componentName == 'uan') {
              item.displayName = 'UAN'
            }else if (item.componentName == 'twentysixas') {
              item.displayName = 'Form 26 AS'
            }else if (item.componentName == 'credittrans') {
              item.displayName = 'Credit Check - TransUnion'
            }else if (item.componentName == 'epfo') {
              item.displayName = 'EPFO Check'
            }else if (item.componentName == 'crconline') {
              item.displayName = 'Court Record (CRC ) - Law Firm (Online)'
            }else if (item.componentName == 'ofac') {
              item.displayName = 'OFAC Check'
            }else if (item.componentName == 'socialmedia') {
              item.displayName = 'Social Media Search'
            }else if(item.componentName == 'globalmediasearch'){
              item.displayName = 'Global Media Search'
            }else if(item.componentName == 'facisl3'){
              item.displayName = 'FACIS L3 Check'
            }

          })
          resolve(this.components)
        },
        error2 => {
          this.showError("Error reading profile details")
          resolve(null)
        }
      )
    })
    return promise
  }

  ////
  getComponentDisplayName(item) {
    let promise = new Promise((resolve, reject) => {
      
      this.componentService.findAComponentForCde(item.component, this.activatedRoute.snapshot.queryParamMap.get('access_token'), this.activatedRoute.snapshot.queryParamMap.get('component_serialNumber')).subscribe(
        response => {
          resolve(response.displayName )
        },
        error => {
          resolve("")
        }
      )
    })
    return promise
  }
  setComponentMenuItems() {
    let promise = new Promise((resolve, reject) => {
      this.components.forEach(item => {
        console.log("Item in candidate data entry ", item)
        let childItems = []
        for (let i = 0; i < item.maxChecks; i++) {
          childItems.push({ displayName: item.displayName + "-" + (i + 1), component_id: item.component, componentName: item.componentName, route: `candidate/candidatecomponentdataentry`, access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'), component_serialNumber: (i + 1), children: [] })
        }
        console.log("childitems: ", childItems)
        this.navItems.push({ displayName: item.displayName, children: childItems })
        resolve(true)
      })

    })
    return promise
  }
  showError(msg) {
    this.snackBar.open(msg, 'Error', { duration: 4000, horizontalPosition: 'end', verticalPosition: 'top' })
  }
  showMessage(msg) {
    this.snackBar.open(msg, 'Info', { duration: 4000, horizontalPosition: 'end', verticalPosition: 'top' })
  }

}
